import { useTheme } from '@mui/material/styles';
import React from 'react';

const baseStyle = {
    display: 'inline-block',
    padding: '2px 8px',
    borderRadius: 10,
    fontSize: '0.6rem',
    fontWeight: 'bold'
};

const LabelBadge = ({ label, variant = 'default', style }) => {
    const theme = useTheme();
    const colors = theme.palette.labelBadge[variant] || theme.palette.labelBadge.default;
    return (
        <span style={{ ...baseStyle, backgroundColor: colors.background, color: colors.color, ...style }}>{label}</span>
    );
};

export const getStatusVariant = status => {
    if (['ok', 'auto_check'].includes(status)) {
        return 'success';
    }
    if (status === 'info') {
        return 'info';
    }
    if (status && status !== 'no_status') {
        return 'danger';
    }
    return 'default';
};

export default LabelBadge;
